
import Vue from 'vue'
import initialStateVisa from './initialState'
import { cart } from '@/utils/mapping'

const mutations = {
  clearVisaeState(state) {
    state.visas = []
  },
  setVisaInitial(state) {
    state.visas.push(initialStateVisa())
  },
  setToursVisas(state, { visaIndex, visa: { searchId, id, results } }) {
    state.visas[visaIndex].toursVisas = {
      id,
      searchId,
      visas: results
    }
  },
  setVisaVisas(state, { touristIndex, visaIndex, data: { searchId, results, id } }) {
    const collection = results.map(item => cart.visa(item))

    const current = {
      slug: null,
      name: 'Не выбрано',
      price: {
        amount: 0,
        markup: 0,
        currency: collection[0].price.currency
      }
    }

    collection.unshift(current)

    state.visas[visaIndex].visas = {
      ...state.visas[visaIndex].visas,
      searchId
    }

    state.visas[visaIndex].visas.ids[touristIndex] = id
    state.visas[visaIndex].visas.collection[touristIndex] = collection
  },
  updateVisaCurrent(state, { target, value }) {
    const visaIndex = target.split('.')[1]
    const touristIndex = target.split('.')[4]
    const selected = state.visas[visaIndex].visas.selected
    const currentTotalVisasPrice = state.visas[visaIndex].visas.current.price
    let oldVisaPrice = state.visas[visaIndex].visas.collection[touristIndex]
      .find(item => item.slug === selected[touristIndex])

    oldVisaPrice = oldVisaPrice
      ? oldVisaPrice.price
      : {
        amount: 0,
        markup: 0
      }

    let newVisaPrice = state.visas[visaIndex].visas.collection[touristIndex]
      .find(item => item.slug === value)

    newVisaPrice = newVisaPrice
      ? newVisaPrice.price
      : {
        amount: 0,
        markup: 0
      }

    selected[touristIndex] = value

    state.visas[visaIndex].visas.current.price = {
      ...currentTotalVisasPrice,
      amount: currentTotalVisasPrice.amount - oldVisaPrice.amount + newVisaPrice.amount,
      markup: currentTotalVisasPrice.markup - oldVisaPrice.markup + newVisaPrice.markup
    }

    Vue.set(state.visas[visaIndex].visas, 'selected', [...selected])
  },
  resetVisaCollection(state, { visaIndex, touristIndex }) {
    state.visas[visaIndex].visas.collection[touristIndex] = []
  },
  updateVisaLoadingStatus(state, { touristIndex, visaIndex, status }) {
    const loadingStatuses = state.visas[visaIndex].visas.isLoading
    loadingStatuses[touristIndex] = status

    Vue.set(state.visas[visaIndex].visas, 'isLoading', [...loadingStatuses])
  },
  setVisaCities(state, { visaIndex, cities }) {
    state.visas[visaIndex].cities = cities
  },
  setCollectionBaseLength(state, { visaIndex, length }) {
    state.visas[visaIndex].visas.collection = Array(length).fill([])
  },
  setSelectedBaseLength(state, { visaIndex, length }) {
    state.visas[visaIndex].visas.selected = Array(length).fill(null)
  },
  setLoadingBaseLength(state, { visaIndex, length }) {
    state.visas[visaIndex].visas.isLoading = Array(length).fill(false)
  },
  setIdsBaseLength(state, { visaIndex, length }) {
    state.visas[visaIndex].visas.ids = Array(length).fill(null)
  }
}

export default mutations